import * as React from 'react';

export function SvgLockFill() {
  return (
    <span aria-hidden={true} data-testid="ads-refreshed-icon">
      <svg viewBox="0 0 12 12">
        <path
          fill="currentColor"
          fillRule="evenodd"
          d="M6 1.5A1.5 1.5 0 0 0 4.5 3v2.5h3V3A1.5 1.5 0 0 0 6 1.5m3 4.01V3a3 3 0 0 0-6 0v2.51c-.844.094-1.5.809-1.5 1.678v3.125c0 .931.756 1.687 1.688 1.687h5.624c.932 0 1.688-.755 1.688-1.687V7.187c0-.868-.656-1.583-1.5-1.677"
          clipRule="evenodd"
        />
      </svg>
    </span>
  );
}
